import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { groupBy, minBy, maxBy, range } from 'lodash'
import MessageCard from '../../../../../components/card/MessageCard'
import i18n from 'simple-react-i18n'
import React from 'react'
import QualityOverviewTableDto from './QualityOverviewTableDto'
import { getLabel, getLabelTruncate, getTruncate } from '../../../../../utils/StoreUtils'
import QualityOverviewTableStatsDto from './QualityOverviewTableStatsDto'
import { getBeginingOfTheYear, getDate, getEndOfTheYear } from '../../../../../utils/DateUtil'
import { getStatuses } from '../../../../../utils/QualityUtils'
import { nbPerPageLabel30 } from '../../../../../referencial/constants/ReferencialConstants'
import useActions from '../../../../../utils/customHook/useActions'
import PropTypes from 'prop-types'
import useListIndexed from 'utils/customHook/useListIndexed'
import { ALIGN, CardTable } from 'components/datatable/NewTable'
import { push } from '@lagunovsky/redux-react-router'
import { getStationDesignation } from 'utils/StationUtils'

const getStatusColor = status => {
    switch (status) {
        case 3:
            return 'green'
        case 2:
            return 'lightgreen'
        case 4:
            return 'blue'
        default:
            return 'grey'
    }
}

const QualityIntegrationOverviewTable = ({
    operationResults = [],
    operationStats = [],
    stations = [],
}) => {
    const {
        citiesIndex,
    } = useSelector(store => ({
        citiesIndex: store.CityReducer.citiesIndex,
    }), shallowEqual)

    const minYear = minBy(operationResults, 'year')?.year
    const maxYear = maxBy(operationResults, 'year')?.year
    const listOfYear = range(minYear, maxYear + 1, 1).reverse()

    const groups = groupBy(operationResults, 'id')
    const groupsStats = useListIndexed(operationStats)

    const dispatch = useDispatch()

    const data = stations.map(qualito => {
        const stats = groupsStats[qualito.id]

        const cityLabel = qualito?.townCode ? citiesIndex[qualito?.townCode]?.name : ''

        const baseObj = {
            code: { value: getStationDesignation(qualito), cellType: 'string' },
            name: { value: getTruncate(qualito?.name, 25), tooltip: qualito?.name?.length > 25 ? qualito?.name : undefined },
            city: { value: getLabelTruncate(cityLabel, qualito?.townCode, 25), tooltip: cityLabel?.length > 25 ? cityLabel : undefined },
            startDate: { value: getDate(stats?.start), sortValue: stats?.start, format: 'dd/MM/yyyy', cellType: 'date' },
            endDate: { value: getDate(stats?.end), sortValue: stats?.end, format: 'dd/MM/yyyy', cellType: 'date' },
            nbSample: { value: stats?.operations || 0 },
            analysis: { value: stats?.analysis || 0 },
            id: { value: qualito?.id },
        }

        const years = groups[qualito.id] || []

        const yearProps = years.reduce((acc, yearObj) => {
            acc[yearObj.year] = {
                value: yearObj.count,
                color: getStatusColor(yearObj.status),
                tooltip: getLabel(getStatuses(), yearObj.status, undefined, undefined, i18n.brute),
                onClick: () => {
                    dispatch(push(`/station/quality/${qualito.id}/suiviPC?startDate=${getBeginingOfTheYear(yearObj.year)}&endDate=${getEndOfTheYear(yearObj.year)}`))
                },
            }
            return acc
        }, {})

        return { ...baseObj, ...yearProps }
    })

    const headers = [{ key: 'code', sticky: ALIGN.LEFT, width: 150 }, { key: 'city', sticky: ALIGN.LEFT, width: 300 }, { key: 'name', sticky: ALIGN.LEFT, width: 250 }, 'startDate', 'endDate', 'nbSample', 'analysis', ...listOfYear.map(y => `${y}`)]

    useActions(() => {
        return {
            export: () => {
                return {
                    data: data.length ? [
                        { ...data[0], headers },
                        ...data.slice(1),
                    ] : [],
                    exportType: 'xlsx',
                    titleFile: i18n.integrationOverview,
                }
            },
        }
    }, [data])

    if (!operationResults.length) {
        return <MessageCard>{i18n.noOperationForTheseCriteria}</MessageCard>
    }

    return (
        <div className='padding-top-1'>
            <CardTable
                title={i18n.watchpoints}
                rows={data}
                headers={headers}
                rowsPerPageOptions={nbPerPageLabel30}
                onClickRow={ (e) => {
                    dispatch(push(`/station/quality/${e.id.value}/suiviPC`))
                }}
            />
        </div>
    )
}

QualityIntegrationOverviewTable.propTypes = {
    operationResults: PropTypes.arrayOf(PropTypes.instanceOf(QualityOverviewTableDto)),
    operationStats: PropTypes.arrayOf(PropTypes.instanceOf(QualityOverviewTableStatsDto)),
    stations: PropTypes.shape({/* qualitometer */}),
}

export default QualityIntegrationOverviewTable
